import * as React from "react";

// router imports
import {Route, RouteProps, Redirect} from 'react-router-dom';
import {RouteComponentProps} from 'react-router';

import {Client} from "../services/HATEOASClient";
import AccessDeniedView from "../views/AccessDeniedView";

interface IAccessRequirement {
    /** An object that contains a "links" property (e.g. baseLinks). */
    linkContainer: any;

    /**
     * A list of property names of HATEOASClient requests to check for
     * inside the linkContainer (e.g. ["GET_technicalData", "GET_adminArea"]).
     */
    requestNames: string[];
}

interface IAuthorizedRouteProps extends RouteProps {
    /**
     * The communication channel to the back end.
     * Used to check whether authentication of the uesr.
     */
    client: Client;

    /** Optional collection of access requirements for the route. */
    access?: IAccessRequirement[];

    /** Properties to forward to the given component after authorization. */
    componentProps?: object;

    /** Optional property for previous location */
    from?: Location;
}

/** A Route wrapper that requires authorizarion before showing the given component. */
const AuthorizedRoute: React.SFC<IAuthorizedRouteProps> = (authRouteProps) => {
    if (!authRouteProps.component) {
        throw new Error("Required 'component' property is missing.");
    }

    let missingLinks: string[] = [];
    if (authRouteProps.access) {
        // Check whether the user was granted the specified access links from
        // the back end and collect all missing request names and display them.
        authRouteProps.access.forEach((requirement: IAccessRequirement) => {
            requirement.requestNames.forEach((requestName: string) => {
                if (requirement.linkContainer) {
                    // @ts-ignore
                    const request = authRouteProps.client[requestName] &&
                       // @ts-ignore
                        authRouteProps.client[requestName](requirement.linkContainer);
                    if (request && !request.canExecute()) {
                        missingLinks.push(requestName);
                    }
                }
            });
        });
    }

    return (
        <Route
            // React router ignores 'render' if 'component' is available; forward all RouteProps
            // except 'component' because we want to use our own 'render' method.
            {...{...authRouteProps, component: undefined}}
            render={(routeComponentProps: RouteComponentProps<any>): React.ReactNode => {
                let Component = authRouteProps.component as React.ComponentType<RouteComponentProps<any>>;
                let combinedProps = Object.assign(
                    {},
                    routeComponentProps,
                    authRouteProps.componentProps,
                    {from: authRouteProps.from}
                );

                if (missingLinks.length > 0) {
                    // render the AccessDeniedView component if we are missing
                    // links/privileges for the requested site.
                    Component = AccessDeniedView as React.ComponentType<RouteComponentProps<any>>;
                    combinedProps = Object.assign(combinedProps, {missingLinks: missingLinks});
                }
                if(!authRouteProps.client.isAuthenticated()) {
                  localStorage.setItem('redirect',routeComponentProps.location.pathname + routeComponentProps.location.search);
                }
                return (
                    authRouteProps.client.isAuthenticated()
                        ? <Component {...combinedProps} />
                        : <Redirect to={{pathname: "/login", state: {from: routeComponentProps.location}}} />
                );
            }}
        />
    );
};

export default AuthorizedRoute;



// WEBPACK FOOTER //
// ./src/components/AuthorizedRoute.tsx